let cartPrice;
(async function(){

    window.getCart = async () => {
        const cartData = await fetch('/cart.json');
        try {
            if(!cartData.ok){
                throw new Error('Error network')
            }
            const getCartData = await cartData.json();
            cartPrice = getCartData.total_price;
            return getCartData;
        } catch (error) {
            console.error(error)
        }
    }
}())